export const remToPx = (rem, fontSize) => rem * fontSize;
